<template>
  <v-list-item-content>
    <v-list-item-subtitle>Saldo p/ emissão de contratos</v-list-item-subtitle>
    <v-list-item-title class="font-weight-bold subtitle-1">
      <v-progress-circular
        indeterminate
        v-if="loading"
        width="2"
        size="25"
      ></v-progress-circular>
      <span>{{ saldoDisponivel }} Kgs</span>
    </v-list-item-title>
  </v-list-item-content>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  props: {
    codvendedor: { type: Number, required: true },
    saldovendedor: { type: Number, required: true },
  },
  data: () => ({
    loading: true,
    saldoDisponivel: 0,
  }),
  methods: {
    ...mapGetters("pedidos", ["getSaldoUsadoContrato"]),
    ...mapMutations("pedidos", ["setVendedorSaldo"]),
  },
  async created() {
    this.loading = true;
    this.setVendedorSaldo(this.codvendedor);
    var saldoUsado = await this.getSaldoUsadoContrato();    
    this.saldoDisponivel = this.saldovendedor - saldoUsado;
    if (this.saldoDisponivel <= 0) {
      this.saldoDisponivel = 0;
    }
    this.loading = false;
  },
};
</script>

<style>
</style>